import { createSlice } from "@reduxjs/toolkit";

import warrantyInitialState from "slices/warranty/warranty-initial-state";
import {
  getAllWarrantiesThunk,
  getDefaultWarrantiesThunk,
  deleteBrandModelWarrantyThunk,
} from "slices/warranty/warranty-thunks";
import { extractWarrantyList } from "slices/warranty/warranty-utils";

export const WarrantySlice = createSlice({
  name: "WarrantySlice",
  initialState: warrantyInitialState,
  reducers: {},
  extraReducers: {
    [getAllWarrantiesThunk.fulfilled.type]: (state, action) => {
      const { list, total } = extractWarrantyList(action.payload);
      state.warrantyInfo.allWarranties = list;
      state.warrantyInfo.recordsLength = total;
    },
    [getDefaultWarrantiesThunk.fulfilled.type]: (state, action) => {
      const { list } = extractWarrantyList(action.payload);
      state.warrantyInfo.defaultWarranties = list;
    },
    [deleteBrandModelWarrantyThunk.fulfilled.type]: (state, action) => {
      const { id } = action.payload;
      state.warrantyInfo.allWarranties = state.warrantyInfo.allWarranties.filter(
        (item) => item.id !== id
      );
      state.warrantyInfo.defaultWarranties =
        state.warrantyInfo.defaultWarranties.filter((item) => item.id !== id);
      state.warrantyInfo.recordsLength = Math.max(
        0,
        state.warrantyInfo.recordsLength - 1
      );
    },
  },
});

export default WarrantySlice.reducer;
